import { useAtom } from 'jotai';
import axiosClient from 'lib/axiosClient';
import { useSnackbar } from 'notistack';
import { useState } from 'react';
import { user } from 'store/public/user';

import { setUser } from '../../../utils/js/user';

export const useGetProfile = () => {
  const [profileLoading, setProfileLoading] = useState(true);

  const [, setUserState] = useAtom(user);

  const { enqueueSnackbar } = useSnackbar();

  const getProfile = () => {
    setProfileLoading(true);

    axiosClient
      .get('/Account/GetProfileInfo')
      .then(res => {
        if (res.data.status === 200) {
          setUserState(res.data.value);
          setUser(res.data.value);
        } else {
          enqueueSnackbar(res.data?.message, { variant: 'error' });
        }
      })
      .catch(err =>
        enqueueSnackbar(err.response?.message, { variant: 'error' }),
      )
      .finally(() => setProfileLoading(false));
  };

  return { getProfile, profileLoading };
};
